export default "__VITE_ASSET__BjaTpohj__"